export interface PreviousMonthData {
  days: number;
  duration: number;
  sessions: number;
}

export interface MetricsDelta {
  days: number;
  duration: number;
  sessions: number;
}

export default class Metrics {
  /**
   * Calculate delta (difference) between current and previous month metrics
   * @param current - Current month metrics
   * @param previous - Previous month metrics
   * @returns Delta object with differences
   */
  static calculateDelta(
    current: PreviousMonthData,
    previous: PreviousMonthData | null | undefined
  ): MetricsDelta {
    if (!previous) {
      return {
        days: 0,
        duration: 0,
        sessions: 0,
      };
    }

    return {
      days: current.days - previous.days,
      duration: current.duration - previous.duration,
      sessions: current.sessions - previous.sessions,
    };
  }

  /**
   * Determine if a delta is positive, negative, or zero
   * @param delta - Delta value
   * @returns "positive", "negative", or "zero"
   */
  static deltaDirection(delta: number): "positive" | "negative" | "zero" {
    if (delta > 0) return "positive";
    if (delta < 0) return "negative";
    return "zero";
  }
}
